import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 justify-between gap-2 lg:grid-cols-6" }
const _hoisted_2 = { class: "col-span-3 flex items-center gap-3" }
const _hoisted_3 = { class: "flex items-center gap-1.5" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "text-gray-700 text-sm" }
const _hoisted_6 = { class: "py-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col-span-3 flex items-center justify-end gap-3" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_FolderPlusIcon = _resolveComponent("FolderPlusIcon")!
  const _component_ChevronDownIcon20 = _resolveComponent("ChevronDownIcon20")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_FolderMinusIcon = _resolveComponent("FolderMinusIcon")!
  const _component_DeletePhotosConfirmationModalComponent = _resolveComponent("DeletePhotosConfirmationModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass({'sticky top-20 z-25 w-[inherit] rounded-md bg-white sm:bg-white/80 sm:backdrop-filter sm:backdrop-blur-lg shadow-xs px-1.5 py-2 mt-2 lg:-mt-13': true, 'hidden': _ctx.selected.length === 0})
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deselectAll && _ctx.deselectAll(...args)), ["prevent"])),
              disabled: _ctx.isDeletingPhotosList,
              class: "rounded-sm p-1 text-sm font-semibold text-gray-900 hover:shadow-xs hover:bg-gray-100 cursor-pointer"
            }, [
              _createVNode(_component_XMarkIcon, {
                class: "size-5 text-gray-700",
                "aria-hidden": "true"
              })
            ], 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t('photos_list_controls.selected')) + ": ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.selected.length), 1)
            ])
          ]),
          ((!_ctx.folder || (_ctx.folder && _ctx.folder?.slug != 'trash')) && _ctx.foldersToMove.length !== 0)
            ? (_openBlock(), _createBlock(_component_Menu, {
                key: 0,
                as: "div",
                class: "ml-auto lg:ml-0 relative inline-block text-left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_MenuButton, { class: "inline-flex w-full justify-center gap-x-1.5 rounded-md bg-gray-100 px-2 py-1.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-100 cursor-pointer" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FolderPlusIcon, {
                          class: "size-5 text-gray-400",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('photos_list_controls.add_to_folder')) + " ", 1),
                        _createVNode(_component_ChevronDownIcon20, {
                          class: "-mr-1 size-5 text-gray-400",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MenuItems, { class: "absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foldersToMove, (_folder, folderIndex) => {
                              return (_openBlock(), _createBlock(_component_MenuItem, {
                                key: `controls-folders-list-${_folder.id}-${folderIndex}`
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("a", {
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.toFolder = _folder),
                                    class: _normalizeClass([_folder.id == _ctx.toFolder?.id ? 'bg-gray-100 text-gray-900 outline-hidden' : 'text-gray-700', 'hover:bg-gray-50 block px-4 py-2 text-sm flex items-center gap-2'])
                                  }, [
                                    _createElementVNode("span", null, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        class: "size-1.5",
                                        style: _normalizeStyle({fill: _folder.color}),
                                        viewBox: "0 0 6 6",
                                        "aria-hidden": "true"
                                      }, _cache[6] || (_cache[6] = [
                                        _createElementVNode("circle", {
                                          cx: "3",
                                          cy: "3",
                                          r: "3"
                                        }, null, -1)
                                      ]), 4))
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(_folder.title), 1)
                                  ], 10, _hoisted_7)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.folder && _ctx.folder?.slug != 'trash')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "w-full lg:w-auto rounded-sm px-2 py-1 text-sm font-medium text-gray-900 bg-white hover:shadow-xs ring-1 ring-gray-100 hover:bg-gray-100 hover:text-gray-900 cursor-pointer flex items-center gap-2 justify-center",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeFromFolder && _ctx.removeFromFolder(...args)), ["prevent"]))
              }, [
                _createVNode(_component_FolderMinusIcon, {
                  class: "size-5 text-gray-400",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('photos_list_controls.remove_from_folder')), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.folder && _ctx.folder?.slug == 'trash')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "w-full lg:w-auto rounded-sm px-2 py-1 text-sm font-medium text-blue-700 bg-white hover:shadow-xs ring-1 ring-blue-700 hover:bg-blue-700 hover:text-white cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.recoverSelected && _ctx.recoverSelected(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('photos_list_controls.recover')), 1))
                  : _createCommentVNode("", true),
                (!_ctx.folder)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "w-full lg:w-auto rounded-sm px-2 py-1 text-sm font-medium text-gray-900 bg-white hover:shadow-xs ring-1 ring-gray-100 hover:bg-gray-100 hover:text-gray-900 cursor-pointer",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteAll && _ctx.deleteAll(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('photos_list_controls.delete_all')), 1))
                  : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)), ["prevent"])),
            disabled: _ctx.isDeletingPhotosList,
            class: "w-full lg:w-auto justify-center rounded-sm px-2 py-1 text-sm font-medium text-red-700 bg-white hover:shadow-xs ring-1 ring-red-700 hover:bg-red-700 hover:text-white cursor-pointer flex items-center gap-2"
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              fill: "currentColor",
              class: "bi bi-trash2",
              viewBox: "0 0 16 16"
            }, [
              _createElementVNode("path", { d: "M14 3a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2zM3.215 4.207l1.493 8.957a1 1 0 0 0 .986.836h4.612a1 1 0 0 0 .986-.836l1.493-8.957C11.69 4.689 9.954 5 8 5c-1.954 0-3.69-.311-4.785-.793z" })
            ], -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('photos_list_controls.delete_selected')), 1)
          ], 8, _hoisted_9)
        ])
      ])
    ], 2),
    _createVNode(_component_DeletePhotosConfirmationModalComponent, {
      open: _ctx.confirmations.deleteAll || _ctx.confirmations.deleteSelected || _ctx.confirmations.recoverSelected,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmations.recoverSelected = _ctx.confirmations.deleteSelected = _ctx.confirmations.deleteAll = false)),
      onConfirmAction: _ctx.confirmationModalAction,
      title: _ctx.modalTitle,
      message: _ctx.modalMessage,
      "button-text": _ctx.modalButtonText,
      isLoading: _ctx.isDeletingPhotosList || _ctx.isRecoveringPhotosList
    }, null, 8, ["open", "onConfirmAction", "title", "message", "button-text", "isLoading"])
  ], 64))
}